export type PageShellPresentation = 'default' | 'immersive'

const pageShellPresentationState = shallowRef<PageShellPresentation>('default')
const pageShellPresentationOwners = new Map<symbol, PageShellPresentation>()

function syncPageShellPresentation() {
  const presentations = Array.from(pageShellPresentationOwners.values())
  pageShellPresentationState.value = presentations[presentations.length - 1] || 'default'
}

export function usePageShellPresentation(presentation?: MaybeRefOrGetter<PageShellPresentation>) {
  if (presentation !== undefined) {
    const owner = Symbol('page-shell-presentation')

    watchEffect(() => {
      pageShellPresentationOwners.set(owner, toValue(presentation))
      syncPageShellPresentation()
    })

    onBeforeUnmount(() => {
      pageShellPresentationOwners.delete(owner)
      syncPageShellPresentation()
    })
  }

  return pageShellPresentationState
}

export function resetPageShellPresentation() {
  pageShellPresentationOwners.clear()
  pageShellPresentationState.value = 'default'
}
